<template>
  <div class="flex flex-col gap-4 border-y py-8 md:py-10" v-if="posts?.length">
    <AtomBlockHeaderSeo 
      :label="$t('city.start.articles.label')"
      :heading="$t('city.start.articles.heading', { city: fat.city?.name })"
    />
    <div class="-mx-[4vw]">
      <div class="w-full overflow-y-scroll no-scrollbar px-[4vw]">
        <div class="flex items-stretch gap-6 sm:gap-x-8">
          <div class="max-md:min-w-[12rem]" :class="{ 'md:w-1/3': posts.length <= 3, 'md:w-1/4': posts.length === 4 }" v-for="post in posts" :key="post.id">
            <NuxtLink :to="post.path" class="block min-h-full bg-mist rounded">
              <div class="bg-black w-full rounded-t overflow-hidden aspect-square">
                <AtomImage class="object-cover" :src="post.image?.src?.medium" :alt="post.image?.alt || post?.title" />
              </div>
              <div class="grid gap-1.5 p-4">
                <h2 class="font-medium font-heading text-lg md:text-xl">{{ post.title }}</h2>
                <p class="text-sm lg:text-base line-clamp-3">{{ post.excerpt }}</p>
              </div>
            </NuxtLink>
          </div>
          <div class="w-0 !opacity-0 md:hidden">&nbsp;</div>
        </div>
      </div>
    </div>
    <NuxtLink class="flex items-center gap-2 mt-2" :to="`/${$t('routes.articles')}/${fat.city?.slug}`">
      <div class="w-5 h-5 flex items-center justify-center rounded-full bg-sky text-ocean">
        <AtomIcon name="chevron-right" class="text-sm" />
      </div>
      <div class="text-sm">{{ $t('shared.showMoreArticles') }}</div>
    </NuxtLink>
  </div>
</template>

<script setup>
const fat = useFatStore()

const props = defineProps({
  posts: {
    type: Array,
    default: () => []
  },
})
</script>